import svc from "../../services/CommunicationsService";
import mapper from '../../services/ModelMapperService';
import {endLoading} from "../globalAction";

export const CLEAR_SELECTED_COMMUNICATION = "communication/CLEAR_SELECTED_COMMUNICATION";
export const DELETE_COMMUNICATION_SUCCESS = "communication/DELETE_COMMUNICATION_SUCCESS";
export const DELETE_COMMUNICATION_FAIL = "communication/DELETE_COMMUNICATION_FAIL";
export const DISMISS_ERROR_ALERT = "communication/DISMISS_ERROR_ALERT";
export const DISSOCIATE_EVENT_SUCCESS = "communication/DISSOCIATE_EVENT_SUCCESS";
export const DISSOCIATE_EVENT_FAIL = "communication/DISSOCIATE_EVENT_FAIL";
export const GET_COMMUNICATIONS_REPORT_DATA_FAILURE = "communication/GET_COMMUNICATIONS_REPORT_DATA_FAILURE";
export const GET_COMMUNICATIONS_REPORT_DATA_SUCCESS = "communication/GET_COMMUNICATIONS_REPORT_DATA_SUCCESS";
export const GET_PAST_COMMUNICATIONS_SUCCESS = "communication/GET_PAST_COMMUNICATIONS_SUCCESS";
export const GET_PAST_COMMUNICATIONS_FAIL = "communication/GET_PAST_COMMUNICATIONS_FAIL";
export const GET_SINGLE_COMMUNICATION_SUCCESS = "communication/GET_SINGLE_COMMUNICATION_SUCCESS";
export const GET_SINGLE_COMMUNICATION_FAILURE = "communication/GET_SINGLE_COMMUNICATION_FAILURE";
export const POSTING_TO_API = "communication/POSTING_TO_API";
export const SAVE_EVENT_ASSOCIATION_SUCCESS = "communication/SAVE_EVENT_ASSOCIATION_SUCCESS";
export const SAVE_EVENT_ASSOCIATION_FAIL = "communication/SAVE_EVENT_ASSOCIATION_FAIL";
export const SEND_COMMUNICATION_SUCCESS = "communication/SEND_COMMUNICATION_SUCCESS";
export const SEND_COMMUNICATION_FAIL = "communication/SEND_COMMUNICATION_FAIL";
export const SET_SELECTED_EVENT_ID = "communication/SET_SELECTED_EVENT_ID";

export function deleteCommunication(communicationId) {
    return (dispatch) => {
        dispatch(setPosting());

        return svc.deleteCommunication(communicationId)
            .then(() => { dispatch({type: DELETE_COMMUNICATION_SUCCESS}); })
            .catch(error => dispatch({type: DELETE_COMMUNICATION_FAIL, error: JSON.stringify(error.stack)}));
    };
}

export function dismissErrorAlert() {
    return {type: DISMISS_ERROR_ALERT};
}

export function dissociateCommunicationEvent(communicationId) {
    return (dispatch) => {
        dispatch(setPosting());

        return svc.dissociateEvent(communicationId)
            .then(communication => {
                const mappedCommunication = mapper.mapCommunicationDetail(communication);
                dispatch({type: DISSOCIATE_EVENT_SUCCESS, communication: mappedCommunication});
            })
            .catch(error => dispatch({type: DISSOCIATE_EVENT_FAIL, error: JSON.stringify(error.stack)}));
    };
}

export function getCommunication(communicationId) {
    return dispatch => svc.getCommunication(communicationId)
        .then(communication => {
            const mappedCommunication = mapper.mapCommunicationDetail(communication);
            dispatch({type: GET_SINGLE_COMMUNICATION_SUCCESS, communication: mappedCommunication});
        })
        .catch(error => dispatch({type: GET_SINGLE_COMMUNICATION_FAILURE, error: JSON.stringify(error.stack)}));
}

export function getCommunicationsReportData() {
    return dispatch => svc.getCommunicationsReportData()
        .then(reportData => {
            const summaryReportData = mapper.mapCommunicationSummaryReportData(reportData);
            const detailedReportData = mapper.mapCommunicationDetailedReportData(reportData);
            dispatch({type: GET_COMMUNICATIONS_REPORT_DATA_SUCCESS, summaryReportData: summaryReportData, detailedReportData: detailedReportData});
        })
        .catch(error => dispatch({type: GET_COMMUNICATIONS_REPORT_DATA_FAILURE, error: JSON.stringify(error.stack)}));
}

export function getPastCommunications() {
    return (dispatch) => {
        return svc.retrievePastCommunications()
            .then((result) => {
                const sortedCommunications = mapper.mapCommunicationsList(result);
                dispatch({type: GET_PAST_COMMUNICATIONS_SUCCESS, pastCommunications: sortedCommunications});
                dispatch(endLoading());
            })
            .catch(error => {
                dispatch({type: GET_PAST_COMMUNICATIONS_FAIL, error: JSON.stringify(error.stack)});
                dispatch(endLoading());
            });
    };
}

export function saveEventAssociation(communicationId, eventId) {
    return (dispatch) => {
        dispatch(setPosting());

        return svc.saveEventAssociation(communicationId, eventId)
            .then(communication => {
                const mappedCommunication = mapper.mapCommunicationDetail(communication);
                dispatch({type: SAVE_EVENT_ASSOCIATION_SUCCESS, communication: mappedCommunication});
            })
            .catch(error => dispatch({type: SAVE_EVENT_ASSOCIATION_FAIL, error: JSON.stringify(error.stack)}));
    };
}

export function sendCommunication(communicationId) {
    return (dispatch) => {
        dispatch(setPosting());

        return svc.sendCommunication(communicationId)
            .then(() => { dispatch({type: SEND_COMMUNICATION_SUCCESS}); })
            .catch(error => dispatch({type: SEND_COMMUNICATION_FAIL, error: JSON.stringify(error.stack)}));
    };
}

export function setPosting() {
    return {type: POSTING_TO_API};
}
